import React from "react";
import MainContext from "contexts/main";
import { UserDataContainer } from "./style";
import Separator from "components/separator";
import { Row, Col } from "react-bootstrap";
import moment from "moment-jalaali";
import provinces from "lib/provinces";
import { FiEdit3 } from "react-icons/fi";
const UserData = ({ goTo }) => {
  const { user } = React.useContext(MainContext);
  const inforamtion = user?.profile.information;
  const getProvinceCity = (province, city = false) => {
    let provinceTitle = "";
    let cityTitle = "";
    for (let i = 0; i < provinces.length; i++) {
      if (provinces[i].id === Number(province)) {
        provinceTitle = provinces[i].title;
        if (city) {
          for (let j = 0; j < provinces[i].cities.length; j++) {
            console.log(provinces[i].cities[j].id);
            if (provinces[i].cities[j].id == city) {
              cityTitle = provinces[i].cities[j].title;
              break;
            }
          }
        }
        break;
      }
    }
    if (city) {
      return cityTitle;
    } else {
      return provinceTitle;
    }
  };
  const specificUserDataView = () => {
    if (inforamtion.user_type === "person") {
      return (
        <>
          <Separator title="اطلاعات مشتری(حقیقی)" />
          <Row>
            <Col sm={12} md={3}>
              <div className="item">
                <span>نام:</span>
                <span>{inforamtion.first_name}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>نام خانوادگی:</span>
                <span>{inforamtion.last_name}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>نام پدر:</span>
                <span>{inforamtion.father_name}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>شماره شناسنامه:</span>
                <span>{inforamtion.id_number}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>سریال شناسنامه:</span>
                <span>{inforamtion.id_number_series}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>جنسیت:</span>
                <span>{inforamtion.gender}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>تاریخ تولد:</span>
                <span>
                  {moment(inforamtion.birthday, "YYYY-M-D").format("jYYYY/jM/jD")}
                </span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>تاریخ صدور شناسنامه:</span>
                <span>
                  {moment(inforamtion.id_number_creation_date, "YYYY-M-D").format("jYYYY/jM/jD")}
                </span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>استان صدور شناسنامه:</span>
                <span>{getProvinceCity(inforamtion.id_number_province)}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>شهر صدور شناسنامه:</span>
                <span>
                  {getProvinceCity(
                    inforamtion.id_number_province,
                    inforamtion.id_number_city
                  )}
                </span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>استان تولد:</span>
                <span>{getProvinceCity(inforamtion.birthday_province)}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>شهر محل تولد:</span>
                <span>
                  {getProvinceCity(
                    inforamtion.birthday_province,
                    inforamtion.birthday_city
                  )}
                </span>
              </div>
            </Col>

            <Col sm={12} md={3}>
              <div className="item">
                <span>نوع پلاک درخواستی:</span>
                <span>{inforamtion.type_of_plate}</span>
              </div>
            </Col>
          </Row>
        </>
      );
    } else {
      return (
        <>
          <Separator title="اطلاعات مشتری(حقوقی)" />
          <Row>
            <Col sm={12} md={3}>
              <div className="item">
                <span>نوع شرکت:</span>
                <span>{inforamtion.company_type}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>نام شرکت:</span>
                <span>{inforamtion.company_name}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>شناسه ملی:</span>
                <span>{inforamtion.company_national_code}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>کد اقتصادی:</span>
                <span>{inforamtion.company_commercial_code}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>شماره ثبت:</span>
                <span>{inforamtion.company_register_code}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>شماره معرفی نامه:</span>
                <span>{inforamtion.company_letter_of_introduction_number}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>تاریخ ثبت شرکت:</span>
                <span>
                  {moment(inforamtion.company_register_date, "YYYY-M-D")
                    .format("jYYYY/jM/jD")}
                </span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>استان ثبت شرکت:</span>
                <span>
                  {getProvinceCity(inforamtion.company_register_province)}
                </span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>شهر ثبت شرکت:</span>
                <span>
                  {getProvinceCity(
                    inforamtion.company_register_province,
                    inforamtion.company_register_city
                  )}
                </span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>تاریخ معرفی نامه:</span>
                <span>
                  {moment(
                    inforamtion.company_letter_of_introduction_date,
                    "YYYY-M-D"
                  )
                    .format("jYYYY/jM/jD")}
                </span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>کد ملی نماینده:</span>
                <span>{inforamtion.company_person_national_code}</span>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="item">
                <span>نوع پلاک درخواستی:</span>
                <span>{inforamtion.company_type_of_plate}</span>
              </div>
            </Col>
          </Row>
        </>
      );
    }
  };
  return (
    <UserDataContainer>
      {goTo ? <FiEdit3 className="edit-icon" onClick={goTo} /> : ""}
      {specificUserDataView()}
      <Separator title="آدرس" />
      <Row>
        <Col sm={12} md={3}>
          <div className="item">
            <span>استان:</span>
            <span>{getProvinceCity(inforamtion.address_province)}</span>
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="item">
            <span>شهر:</span>
            <span>
              {getProvinceCity(
                inforamtion.address_province,
                inforamtion.address_city
              )}
            </span>
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="item">
            <span>خیابان اصلی:</span>
            <span>{inforamtion.address_primary_street}</span>
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="item">
            <span>خیابان فرعی:</span>
            <span>{inforamtion.address_secondary_street}</span>
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="item">
            <span>کوچه:</span>
            <span>{inforamtion.address_alley}</span>
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="item">
            <span>پلاک:</span>
            <span>{inforamtion.address_no}</span>
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="item">
            <span>کد پستی:</span>
            <span>{inforamtion.address_postal_code}</span>
          </div>
        </Col>
      </Row>
      <Separator title="اطلاعات بانکی" />
      <Row>
        <Col sm={12} md={6}>
          <div className="item">
            <span>شماره شبا:</span>
            <span>{inforamtion.bank_sheba}</span>
          </div>
        </Col>
        <Col sm={12} md={6}>
          <div className="item">
            <span>نام بانک:</span>
            <span>{inforamtion.bank_name}</span>
          </div>
        </Col>
      </Row>
      <Separator title="اطلاعات تماس" />
      <Row>
        <Col sm={12} md={6}>
          <div className="item">
            <span>تلفن همراه:</span>
            <span>{inforamtion.contact_phone}</span>
          </div>
        </Col>
        <Col sm={12} md={6}>
          <div className="item">
            <span>ایمیل:</span>
            <span>{inforamtion.contact_email}</span>
          </div>
        </Col>
      </Row>
    </UserDataContainer>
  );
};
export default UserData;
